import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=55123c2a&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55123c2a')) {
      api.createRecord('55123c2a', component.options)
    } else {
      api.reload('55123c2a', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=55123c2a&", function () {
      api.rerender('55123c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-229E3io7NnGl6/JS/comp/ImgFallback2.vue"
export default component.exports